import { useAuth } from '../internal/AuthProvider';

interface ForgotPasswordButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: React.ReactNode;
    email?: string;
}

/***
 * A button component that opens the forgot password modal.
 * Uses <a> element to work with existing CSS styling.
 */
export function ForgotPasswordButton({ 
    children, 
    className,
    email,
    ...anchorProps 
}: ForgotPasswordButtonProps): React.ReactElement {
    const { showForgotPassword } = useAuth();

    return (
        <a
            href="/"
            role="button"
            className={className}
            onClick={(e) => {
                e.preventDefault();
                showForgotPassword(email);
            }}
            {...anchorProps}
            title="Forgot Password"
        >
            {children || "Forgot Password?"}
        </a>
    );
}

